import React from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const CHECKOUT = 'https://megapack-maestria-reiki.impultienda.ar/checkout';
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#f3e9f7] py-12 md:py-16 px-4 sm:px-6 relative overflow-hidden border-t border-[#e8d5f0]" data-id="element-311">
      <div className="container mx-auto max-w-3xl" data-id="element-312">
        <div ref={ref1} className={`reveal text-center mb-8 md:mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-313">
          <span className="text-[#c9a14d] text-[10px] sm:text-xs font-bold tracking-[0.25em] uppercase mb-2 block" data-id="element-314">
            🪷 Oferta de relanzamiento
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-[#3d2a5f] mb-3 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-315">
            Tu Camino Empieza Hoy
          </h2>
          <p className="text-[#6b5a85] text-sm md:text-base max-w-xl mx-auto" data-id="element-316">
            Acceso inmediato y de por vida. Sin suscripciones. Una sola
            inversión que cambia tu camino.
          </p>
        </div>

        <div ref={ref2} id="pricing-offer" style={{
        scrollMarginTop: '20px'
      }} className={`reveal max-w-xl mx-auto ${vis2 ? 'is-visible' : ''}`} data-id="element-317">
          {/* Single Product Card */}
          <div className="relative bg-white rounded-2xl p-6 sm:p-8 flex flex-col z-10 border-2 border-[#c9a14d] shadow-[0_20px_50px_rgba(61,42,95,0.1)]" data-id="element-318">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-319">
              <span className="bg-gradient-to-r from-[#c9a14d] to-[#b8945a] text-white text-xs font-bold px-4 py-1.5 rounded-full shadow-lg whitespace-nowrap uppercase tracking-wider" data-id="element-320">
                ⭐ OFERTA ÚNICA
              </span>
            </div>

            <div className="text-center mb-6 mt-2" data-id="element-321">
              <h3 className="text-2xl sm:text-3xl font-bold text-[#3d2a5f] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-322">
                MEGAPACK MAESTRÍA REIKI
              </h3>
              <p className="text-[#c9a14d] font-bold text-sm sm:text-base" data-id="element-323">
                6 Tomos + 5 Bonos · Niveles I, II y Maestría
              </p>
            </div>

            <div className="bg-[#faf5fc] rounded-xl p-4 mb-6 border border-[#e8d5f0]" data-id="element-324">
              <ul className="space-y-3 text-sm text-[#3d2a5f] font-medium" data-id="element-325">
                <li className="flex items-center gap-2" data-id="element-326">
                  <CheckIcon className="w-5 h-5 text-[#c9a14d]" strokeWidth={3} data-id="element-327" />
                  Formación completa desde cero
                </li>
                <li className="flex items-center gap-2" data-id="element-328">
                  <CheckIcon className="w-5 h-5 text-[#c9a14d]" strokeWidth={3} data-id="element-329" />
                  6 Tomos + 5 Bonos incluidos
                </li>
                <li className="flex items-center gap-2" data-id="element-330">
                  <CheckIcon className="w-5 h-5 text-[#c9a14d]" strokeWidth={3} data-id="element-331" />
                  Acceso inmediato y de por vida
                </li>
                <li className="flex items-center gap-2" data-id="element-332">
                  <CheckIcon className="w-5 h-5 text-[#c9a14d]" strokeWidth={3} data-id="element-333" />
                  100% Online y a tu ritmo
                </li>
              </ul>
            </div>

            <div className="text-center mt-auto" data-id="element-334">
              <p className="text-[#6b5a85] text-sm line-through mb-1" data-id="element-335">
                $69.000
              </p>
              <p className="text-5xl sm:text-6xl font-extrabold text-[#3d2a5f] leading-none mb-6" data-id="element-336">
                $19.990{' '}
                <span className="text-xl font-bold text-[#6b5a85]" data-id="element-337">ARS</span>
              </p>

              <a href={CHECKOUT} target="_blank" rel="noopener noreferrer" className="w-full block py-4 md:py-5 rounded-xl text-white font-bold text-sm sm:text-base tracking-wider sm:tracking-widest uppercase text-center transition-all shadow-[0_10px_30px_rgba(201,161,77,0.4)] hover:shadow-[0_15px_40px_rgba(201,161,77,0.5)] hover:-translate-y-1 bg-gradient-to-r from-[#c9a14d] to-[#b8945a] border border-[#c9a14d]" style={{
              fontFamily: "'Inter', sans-serif",
              letterSpacing: '0.05em'
            }} data-id="element-338">
                → QUIERO MI MEGAPACK AHORA
              </a>

              <p className="text-[#6b5a85] text-xs mt-4 flex items-center justify-center gap-2 flex-wrap" data-id="element-339">
                <span data-id="element-340">🛡️ Garantía 7 días</span>
                <span data-id="element-341">•</span>
                <span data-id="element-342">🔒 Pago seguro</span>
                <span data-id="element-343">•</span>
                <span data-id="element-344">💳 Mercado Pago</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}